import {
  Box,
  Text,
  Heading,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { FiUser, FiSettings } from "react-icons/fi";

export default function AccountPage() {
  return (
    <Flex minH="70vh" align="center" justify="center">
      <Box textAlign="center" py={10} px={6}>
        <Box display="inline-block">
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bg="blue.500"
            rounded="50px"
            w="55px"
            h="55px"
            textAlign="center"
          >
            <Icon as={FiUser} w={6} h={6} color="white" />
          </Flex>
        </Box>
        <Heading as="h2" size="xl" mt={6} mb={2}>
          Account Management
        </Heading>
        <Text color="gray.500" fontSize="lg" mb={4}>
          Coming Soon
        </Text>
        <Text color="gray.600" fontSize="md">
          User account settings and profile management features will be available in a future update.
        </Text>
        <Box mt={6}>
          <Icon as={FiSettings} w={5} h={5} color="gray.400" mr={2} />
          <Text display="inline" color="gray.400" fontSize="sm">
            Features in development
          </Text>
        </Box>
      </Box>
    </Flex>
  );
}
